import React from 'react'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { FormComponent } from '../../../components/form/DynamicForm';
import { Form, Validators } from '../../../components/form/DynamicFormTs';
import ACCESS from '../../../ACCESS';
class Cliente extends FormComponent {

  static defaultProps = {
    onSave: () => { }
  }

  componentDidMount() {
    const { hasAccess } = this.context
    this.idCliente = this.props.match.params.id;
    this.esContado = hasAccess(ACCESS.CATALOGO_CLIENTES.CREAR_SOLO_CONTADO)
    const camposDireccion = this.idCliente ? [] : [
      Form.Field('text', 'cliente_cp', 'Codigo Postal', '', [Validators.required], 2),
      Form.Field('text', 'cliente_domicilio', 'Domicilio', '', [Validators.required], 6),
      Form.Field('text', 'cliente_next', 'N. Ext', '', [], 3),
        Form.Field('text', 'cliente_nint', 'N. Int', '', [], 3),
      Form.Field('autocomplete', 'cliente_id_colonia', 'Colonia', '', [Validators.required], 6),
      Form.Field('select', 'cliente_id_estado', 'Estado', '', [Validators.required], 6),
      Form.Field('select', 'cliente_id_ciudad', 'Ciudad', '', [Validators.required], 6),
    ]

    this.FormConfig(
      { defaultUrl: 'cliente/one', saveUrl: 'cliente/save', backUrl: '/Catalogo/Clientes' },
      new Form([
        Form.Field('number', 'cliente', 'Cliente', '', [Validators.required], 4),
        Form.Field('text', 'cliente_rsocial', 'Razón Social', '', [Validators.required], 8),
        Form.Field('radio', 'cliente_fm', 'Persona Fisica / Moral', '', [Validators.required], 4, [{ Label: 'Fisica', Value: "1" }, { Label: 'Moral', Value: "2" }]),
        Form.Field('text', 'cliente_rfc', 'R.F.C.', '', [Validators.required], 8),
        Form.Field('checkbox', 'cliente_dv', 'Repetir RFC', 0, [], 6),
        Form.Field('text', 'cliente_desc', 'Descripción', '', [], 10),
        ...camposDireccion
      ],
        ['Guardar'], this.esContado ? 'Cliente de Contado' : 'Cliente'), this.formData)

    if (this.idCliente)
      this.LoadPreds(this.idCliente)
  }

  formData = async (form) => {
    var Res = await Http.get(`cliente/form-generales?${(this.formEstado && !this.idCliente) ? `e=${this.formEstado}&` : ''}${(this.formCp && !this.idCliente) ? `cp=${this.formCp}` : ''}`);
    if (!Res.error) {
      const { direccion, estados, ciudades } = Res.data;
      let newForm = form
      if (!this.idCliente) {
        newForm = Form.FieldOptions(form, 'cliente_id_estado', estados, 'id', 'estado');
        if (ciudades) newForm = Form.FieldOptions(newForm, 'cliente_id_ciudad', ciudades, 'id', 'ciudad');
        if (direccion && !this.idCliente) {
          newForm = Form.Patch(newForm, { cliente_id_estado: direccion.estado.id, cliente_id_ciudad: direccion.ciudad.id }, false);
          newForm = Form.FieldOptions(newForm, 'cliente_id_colonia', direccion.colonias, 'id', 'colonia');
          newForm = Form.FieldOptions(newForm, 'cliente_id_ciudad', direccion.ciudades, 'id', 'ciudad');
          newForm = Form.FieldMod(newForm, 'cliente_id_estado', 'Disabled', true);
          newForm = Form.FieldMod(newForm, 'cliente_id_ciudad', 'Disabled', true);
        }
      }
      newForm = Form.ValueChange(newForm, {
        cliente_id_estado: this.estadoChange,
        cliente_cp: this.cliCpChange,
        cliente_fm: this.cliFMChange,
      });
      return newForm;
    }
  }

  cliCpChange = async (field) => {
    if (field.Value.length === 5) {
      this.formCp = field.Value;
      this.setState({ FormData: await this.formData(this.state.FormData) });
    }
  }

  estadoChange = async (field) => {
    this.formEstado = field.Value;
    this.setState({ FormData: await this.formData(this.state.FormData) })
  }

  cliFMChange = (field) =>  {
    const { FormData } = this.state;
    let validatorrfc = null
    if (Number(field.Value) === 1) {
      validatorrfc = Validators.rfc_fisica;
    } else {
      validatorrfc = Validators.rfc_moral;
    }

    const newFormData = Form.FieldMod(FormData, 'cliente_rfc', 'Validators', [Validators.required, validatorrfc]);
    this.setState({ FormData: newFormData })
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(Cliente)
